import React from 'react';
import styles from './HandbookImageWhite.module.scss';
import Title from '../../Components/Title/Title';
import Description from '../../Components/Description/Description';
import Button from '../../Components/Button/Button';
import Image from '../../Components/Image/Image';

const HandbookImageWhite = ({ api }) => {
  return (
    <section
      id={api?.id}
      className={`wrapper ${styles.sectionHandbook}`}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      <div className={styles.sectionContainer}>
        <div className={styles.sectionContext} data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out" data-aos-once="false">
          <Title title={api.attributes.title} type="lightTitle fontMedium colorTheme f-300" />
          {!!api.attributes.subTitle && <p className={styles.subTitle}>{api.attributes.subTitle}</p>}
          <Description api={api} type="lightDesc fullImageSec blackFont" />
          <Button api={api} type="lightButton right-images btnBlack smallMarg" />
        </div>
        <div className={styles.sectionImage}>
          <Image
            properties={api.attributes}
            type="animationInside borderBlueAnim"
            animationData={{
              animation: 'zoom-in',
              animationDuration: '1000',
              animationEasing: 'easy-in-out',
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default HandbookImageWhite;
